export const GREETING_DEFAULTS = {
  he: "בברכה,",
  en: "Best Regards,"
};
